import React from 'react'
import { reduxForm } from 'redux-form'
import Fields from './fields'

const LoginForm = () => <Fields />

export default reduxForm({})(LoginForm)
